
import cookies from 'js-cookie';
import { defineComponent, getCurrentInstance, onMounted } from 'vue';
import { commonPvParams, getTargetUrlFromWebOrDesktop } from '@/common/utils';
import { immediateSendLog, reportFMP } from '@/common/radar';
import { autoLaunchAppWarp } from '@/common/call-app';
import { extractTitleFromMetaInfo, getDefaultTitle, getLdJson, getMetaInfo, header, adSenseHeader } from '@/common/seo';
import { setCommonParamsCookiesInServer } from '@/common/common-params';
import { MobilePageSource, ComponentNameMap } from '@/constants/base';
import PwaVideoDetailShare from '@/pages/pwa-share-new/index.vue';
import { RequestSource } from '@/api/base';
import { FeedPageEnum } from '@/store/modules/feed';
import device from '@/common/device-info';

export default defineComponent<any>({
    name: ComponentNameMap.VideoDetail,
    components: {
        PwaVideoDetailShare,
    },
    setup() {
        const { proxy } = getCurrentInstance() as { proxy?: Record<string, any> };
        const sendPv = () => {
            const params = commonPvParams({ defaultPageSource: proxy?.isShareDetail ? MobilePageSource.PwaVideoDetailShare : 'detail' });

            // 获取启动config
            const country = proxy?.$store?.state?.startup?.countryInfo;
            const user_id = cookies.get('user_id');
            immediateSendLog({
                type: 'pv',
                name: proxy?.isShareDetail ? 'PWA_DETAIL_PAGE_SHARE' : 'PWA_DETAIL_PAGE',
                value: {
                    country,
                    user_id,
                    ...params,
                },
            });
        };

        onMounted(async () => {
            reportFMP();
            sendPv();

            const { isAndroid } = device();
            if (isAndroid && proxy?.$store?.state?.abTestModule?.abTestParams?.isDropLaunchApp) {
                // 是安卓并且命中实验，就不拉端
                return;
            }
            setTimeout(() => {
                try {
                    autoLaunchAppWarp(`ikwai://work/${proxy?.$route?.params?.photoId}?target_url=${getTargetUrlFromWebOrDesktop()}`);
                } catch (e) {
                    console.log('launch app error: ', e);
                }
            }, 500);
        });

        return {
            FeedPageEnum,
        };
    },

    async asyncData(ctx) {
        let seoData = [];
        let metaInfoData = [];
        let title = getDefaultTitle(ctx);

        const query = (ctx?.query || {}) as {
            request_source?: string;
            pwa_source?: string;
            photoId?: string;
            share_device_id?: string;
            shareBucket?: string;
        };
        const { request_source } = query;
        const isShareDetail = Number(request_source) === RequestSource.REQUEST_SOURCE_PWA_SHARE_SLIDE;

        if (process.server) {
            setCommonParamsCookiesInServer({
                bucket: ctx.store.state.startup.bucket,
                host: ctx.req.headers.host,
                ctx,
                countryInfo: ctx.store.state.startup.countryInfo,
            });

            try {
                const url = `https://${ctx?.req?.headers?.host}${ctx?.route?.path}` || '';
                // 获取google ldjson 标签
                const seoPromise = getLdJson({ ctx, params: { url } });
                // 获取meta info
                const metaInfoPromise = getMetaInfo({ ctx, params: { url, locale: ctx.req.headers['accept-language'] } });

                const [seoRes, metaInfoRes] = await Promise.all([seoPromise, metaInfoPromise]);

                if (seoRes.status === 200) {
                    seoData = seoRes.data;
                }

                if (metaInfoRes.status === 200) {
                    metaInfoData = metaInfoRes.data;
                    title = extractTitleFromMetaInfo({ ctx, metaInfoData });
                }
            } catch (error) {
                console.log(error);
            }
        }

        return {
            isShareDetail,
            seoData,
            metaInfoData,
            title,
        };
    },

    head() {
        const head = header(this);
        adSenseHeader(head);
        return {
            ...head,
        };
    },
});
